import React from 'react';
import "../../../css/lists/foundInList.scss";

interface ListItem {
  id: string;
  title: string;
  url?: string;
}

function foundInParentLists(lists: ListItem[]): React.JSX.Element {
    let content;
    if (lists.length === 1) {
        content = (
            <>
                {" "}
                <span className='found-in-parent-list'>{lists[0].title}</span>
            </>
        )
    } else if (lists.length === 2) {
        content = (
            <>
                {" "}
                <span className='found-in-parent-list'>{lists[0].title}</span>
                {" and "}
                <span className='found-in-parent-list'>{lists[1].title}</span>
            </>
        );
    } else {
        content = (
            <>
                {" "}
                <span className='found-in-parent-list'>{lists[0].title}</span>
                {" and other locations"}
            </>
        );
    }

    return content
}

const FoundInTile = ({ lists }: { lists: ListItem[] }) => {
    if (!lists || lists.length === 0) return null;

    const foundInLists = foundInParentLists(lists);

    return (
        <div className="content-found-in-tile-wrapper">
            <span>Found in {foundInLists}</span>
        </div>
    );
};

export default FoundInTile;
